// extracted by mini-css-extract-plugin
export default {"openPopupButton":"TitlesLangBar_openPopupButton__3T6IT","redCircle":"TitlesLangBar_redCircle__YTmYO"};